import { render, staticRenderFns } from "./VaimoTruncatedToggle.vue?vue&type=template&id=93a199ba&"
import script from "./VaimoTruncatedToggle.vue?vue&type=script&lang=ts&"
export * from "./VaimoTruncatedToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports